import { TRADE_TYPE } from '../SecurityTrade';

const Big = require('big.js/big.js');

const secRate = new Big(0.000013);
const tafRate = new Big(0.000119);
const tafCap = new Big(5.95);
const cambriaComission = new Big(10.00);

/* --- these functions expect and return Big --- */
const calcCommission = () => cambriaComission;

// SEC fee should be rounded up to the nearest penny Big.js RM 3
const calcSECFee = sellTotalAmt => sellTotalAmt.times(secRate).round(2, 3);

// TAF fee is also rounded up to the nearest penny
const calcTAFFee = (shareTotalQty) => {
  const floatResult = Number.parseFloat(shareTotalQty.times(tafRate).round(2, 3));
  return (Big(Math.min(floatResult, Number.parseFloat(tafCap))));
};


const calcSellingFees = (amount, quantity) =>
  calcSECFee(amount.times(quantity)).plus(calcTAFFee(quantity)).plus(calcCommission());

const calcBuyingFees = () => calcCommission();

/* --- These functions expect float or int and return float or undefined for invalid params --- */
export const calcFees = (tradeDir, tradePrice, requestedShareAmount) => {
  if (Number.isFinite(tradePrice) && Number.isFinite(requestedShareAmount)) {
    const bigPrice = new Big(tradePrice);
    const bigAmount = new Big(requestedShareAmount);
    return (tradeDir === TRADE_TYPE.BUY ?
      Number.parseFloat(calcBuyingFees().round(2, 0)) :
      Number.parseFloat(calcSellingFees(bigPrice.round(2, 0), bigAmount.round(0, 0)).round(2, 0))
    );
  }
  return undefined;
};

export const calcTotal = (tradeDir, tradePrice, requestedShareAmount) => {
  if (Number.isFinite(tradePrice) && Number.isFinite(requestedShareAmount)) {
    const bigPrice = new Big(tradePrice).round(2, 0);
    const bigTotal = new Big(requestedShareAmount).round(0, 0).times(bigPrice);
    const bigFees = new Big(calcFees(
      tradeDir,
      Number.parseFloat(bigPrice),
      Number.parseFloat(Big(requestedShareAmount).round(2, 0)),
    ));
    return (tradeDir === TRADE_TYPE.BUY ?
      Number.parseFloat(bigTotal.plus(bigFees).round(2, 0)) :
      Number.parseFloat(bigTotal.minus(bigFees).round(2, 0)));
  }
  return undefined;
};



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/utils.js